import { useRouter } from 'next/router';

export const useLmsDestinationFromQuery = (): string | null => {
    const router = useRouter();

    const param: string | string[] | undefined = router.query.til;
    const destinations: string[] = param ? (Array.isArray(param) ? param : [param]) : [];

    if (destinations.length === 0) {
        return null;
    }

    const lastSelectedDestinationIndex = destinations.length - 1;

    return destinations[lastSelectedDestinationIndex];
};

const COUNTRY_INDEX = 1;

export const formatDestination = (destination: string | null): string | null => {
    if (destination == null) {
        return null;
    }

    const destinationParts = destination.split(';');
    const lastDestinationPart = destinationParts.length > 2 ? destinationParts[destinationParts.length - 1] : null;

    return destinationParts[COUNTRY_INDEX] + (lastDestinationPart ? `, ${lastDestinationPart}` : '');
};
